import ProjectView from "../../project-view"
import ProjectViews from "../../project-views"
import ErrorProto from "../../../../../../mobile/src_native/core/gd/validation/error"
import ErrorFieldRequired from "../../../../gd/validation/error-field-required"
import EmbedUtils from "../../../../gd/utils/embed"
import ErrorFieldCustom from "../../../../gd/validation/error-field-custom"
import {ProjectView_Link_AccessControl} from "./acl"
import {OpenProjectViewOptions, ProjectViewConfig} from "../../@types";
import {isGDSystemLink, openGDSystemLink} from "../../../../gd/utils/gd-system-link"

export default class ProjectView_Link extends ProjectView {

    public contentUrl   : string

    constructor(viewConfig:ProjectViewConfig, projectViews:ProjectViews) {
        super(viewConfig, projectViews)

        this.name       = _.get(viewConfig, 'name', 'Link')
        this.contentUrl = _.get(viewConfig, 'contentUrl', '')

        this.hasTemplates       = false
    }

    get acl():ProjectView_Link_AccessControl {

        if (!this._acl) {
            this._acl = new ProjectView_Link_AccessControl(this)
        }

        return this._acl
    }

    open(options?: OpenProjectViewOptions) {
        if (!options?.isAutoOpen) {
            if (isGDSystemLink(this.contentUrl)) {
                openGDSystemLink(this.contentUrl)
            } else {
                window.open(this.contentUrl)
            }
        }
    }

    edit() {
        // gd.modals.view.editLinkView(this)
        gd.navigation.goTo(this.url + '/edit')
    }

    copyUrl() {
        gd.utils.copyToClipboard(this.contentUrl)
        gd.growl.success('The URL has been copied to the clipboard.')
    }

    validate():ErrorProto[] | null  {
        const errors = super.validate() || []

        if (!this.name)         errors.push(new ErrorFieldRequired(gd.fields.projectView.name))
        if (!this.contentUrl)   errors.push(new ErrorFieldRequired(gd.fields.projectView.contentUrl))
        if (this.contentUrl && !EmbedUtils.isLink(this.contentUrl)) {
            errors.push(new ErrorFieldCustom(gd.fields.projectView.contentUrl, {message: 'Value should be in a valid URL format'}))
        }

        if (_.isEmpty(errors)) return null
        else return errors
    }

    toJson() {
        const config        = super.toJson()

        config.contentUrl   = this.contentUrl

        return config
    }
}